import { useEffect } from "react";
import { Outlet } from "react-router-dom"

const PublicLayout = () => {
    useEffect(() => {
        if (window.particlesJS) {
            window.particlesJS("particles-js", {
                particles: {
                    number: { value: 40, density: { enable: true, value_area: 800 } },
                    color: { value: "#2bb673" },
                    shape: { type: "circle" },
                    opacity: { value: 1 },
                    size: { value: 5, random: true },
                    move: { enable: true, speed: 6 },
                    line_linked: {
                        enable: true,
                        distance: 150,
                        color: "#ffffff",
                        opacity: 0.4,
                        width: 1
                    }
                },
                interactivity: {
                    detect_on: "canvas",
                    events: {
                        onhover: { enable: false, mode: "repulse" },
                        onclick: { enable: false, mode: "push" },
                        resize: true
                    }
                },
                retina_detect: true
            });
        }

        return () => {
            // Rimuove le particelle quando il componente si smonta per evitare duplicazioni
            const particlesCanvas = document.querySelector("#particles-js canvas");
            if (particlesCanvas) {
                particlesCanvas.remove();
            }
        };
    }, []); // Si esegue solo al mount del componente

     let { version } = require('../../package.json');

    const content = (


        <>
            <div id="particles-js" style={{ position: "absolute", width: "100%", height: "99%" }}></div>

            <div id="layoutAuthentication">
                <div id="layoutAuthentication_content">
                    <main>
                        <div className="container">
                            <Outlet />
                        </div>
                    </main>
                </div>
                <div id="layoutAuthentication_footer" style={{ zIndex: "99" }}>
                    <footer className="py-4 bg-dark mt-auto">
                        <div className="container-fluid px-4">
                            <div className="d-flex align-items-center justify-content-between small">
                                <div className="text-muted">Copyright &copy; EffiHand</div>
                                <div className="text-muted"> v.{version}</div>
                                {/* <div>
                                    <a href="#">Privacy Policy</a>
                                    &middot;
                                    <a href="#">Terms &amp; Conditions</a>
                                </div> */}
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
            <script src="/js/particles.min.js"></script>
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js" crossOrigin="anonymous"></script>
            <script src="js/scripts.js"></script>
        </>

    )

    return content

}

export default PublicLayout